<template>
   <div class='menu-detail batt-swap-page'>
      <img class="w100" src="../../../../assets/images/menu-inset.png" alt=""> 
      <div class="menu-content">
         <div class="menu-content-head">            
            <h2>{{menuInfo.name}}</h2>
            <p class="menu-content-intro">{{menuInfo.introduction}}</p>
            <p class="menu-content-account">{{menuInfo.currencySymbol}}{{menuInfo.price | formatPrice}}<span>/{{menuInfo.cycle | formatStatus(cycles)}}</span></p>
         </div>
         <div class="divide"></div>
         <div class="menu-content-body">
            <!-- 套餐详情 -->
            <h2>{{$t('bstext.bs2')}}:</h2>
            <p v-html="menuInfo.detail"></p>
         </div>
      </div>
      <div class="menu-content-bottom">
         <!-- 使用说明 -->
         <h2>{{$t('bstext.bs3')}}:</h2>
         <p v-html="menuInfo.remark"></p>
      </div>
      <div class="menu-btn">
         <!-- 我要开通 -->
         <bs-button v-if="!isChange&&status==1" class="w100" @click="openService" :disabled="disabled">{{$t('bstext.bs4')}}</bs-button>
         <!-- 下一步 -->
         <bs-button v-if="isChange" class="w100" @click="nextStep">{{$t('bstext.bs5')}}</bs-button>
      </div>
      <bs-popup :visible.sync="visible" width="100%" :title="$t('bstext.bs63')">
         <div class="current-menu">
            <i18n path="bstext.bs64" tag="p">
               <span place="name">{{menuInfo.name}}</span>
            </i18n>
         </div>
         <!-- <p class="current-menu">您申请变更为<span>{{menuInfo.name}}</span>套餐，将于次日生效，变更后本月账单将按照两个套餐实际使用天数计算。请确认！</p> -->
         <!-- <p class="old-menu">{{$t('bstext.bs62')}}</p> -->
          <template v-slot:footer>
             <div class="flex bs-hairline-top" style="padding:32px 16px 40px">
                <!-- 确认变更 -->
               <bs-button style="width: 100%"  @click="editService">{{$t('bstext.bs6')}}</bs-button>
             </div>
          </template>
      </bs-popup>
   </div>
</template>

<script>
export default {
   data () {
      return {
         visible:false,
         id:parseInt(this.$route.params.id),
         isChange:this.$route.query.ischange,
         menuInfo:{},
         disabled:false,
         status:0,
         cycles:[],
      }
   },
   mounted() {
      this.cycles=this.$t('bsstatus.cycles')
      // '套餐变更':'换电套餐'
      document.title = this.isChange?this.$t('bstext.bs7'):this.$t('bstext.bs8')
      this.getServiceInfo()
      this.getUserInfo()
   },
   methods: {
      // 获取用户信息
      getUserInfo(){
         this.$server.getUserInfo({}).then(res=>{
            this.status=res.data.status
         })
      },
      openMenu(){
         this.visible=true
      },
      // 获取套餐信息
      getServiceInfo(){
         this.$appApi.nativeLoading(true,'',0)         
         let req ={
            serviceId:this.id
         }
         this.$server.getServiceInfo(req).then(res=>{
            let info =res.data
            info.introduction=info.introduction.replace(/\s/g,'')
            info.detail=info.detail.replace(/\n/g,'<br/>').replace(/\r\n/g,'<br/>').replace(/\s/g,'')
            info.remark=info.remark.replace(/\n/g,'<br/>').replace(/\r\n/g,'<br/>').replace(/\s/g,'')
            this.menuInfo=info
         }).finally(res=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      editService(){
         this.$appApi.nativeLoading(true,'',0)                  
         let req ={
            serviceId:this.id,
         }
         this.$server.editService(req).then(res=>{
            // 变更成功
            this.$BsMessage({message:this.$t('bstext.bs9')})
            this.$router.go(-2)
         }).finally(res=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      // 开通套餐
      openService(){
         this.$appApi.nativeLoading(true,'',0)         
         this.disabled=true
         let req ={
            serviceId:this.id,
         }
         this.$server.openService(req).then(res=>{
            this.disabled=false
            this.$router.push('/bs/battswap/menuopen')
         }).finally(()=>{
            this.disabled=false
            this.$appApi.nativeLoading(false,'',0)         
         })
      },
      nextStep(){
         this.visible=true
      }
   }
}
</script>

<style lang='less' scoped>
.menu-detail{
   padding-top: 0;
   .menu-content{
      background: #1B1B21;
      border-radius: 4px;
      .menu-content-head{
         padding:16px 12px;
         h2{
            margin-bottom: 4px;
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            color: #F2F2F7;
            line-height: 22px;
         }
         .menu-content-intro{
            margin-bottom: 4px;
            font-size: 14px;
            color: #8F9BA7;
            line-height: 20px;
         }
         .menu-content-account{
            font-size: 18px;
            font-weight: 500;
            color: #F2F2F7;
            line-height: 25px;
            span{
               font-size: 12px;
            }
            i{
               margin-left: 8px;
               font-size: 12px;
               color: #8F9BA7;
               text-decoration: line-through;
            }
         }
      }
      .divide{
         height: 1px;
         background: #2B2B32;
      }
      .menu-content-body{
         padding:16px 12px;
         h2{
            margin-bottom: 8px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #C7CAD1;
            line-height: 20px;
         }
         p{
            font-size: 14px;
            color: #C7CAD1;
            line-height: 20px;
         }
      }
   }
   .menu-content-bottom{
      padding: 24px 12px;
      h2{
         margin-bottom: 8px;  
         height: 20px;
         font-size: 14px;
         font-weight: 400;
         color: #8F9BA7;
         line-height: 20px;
      }
      p{
         font-size: 14px;
         color: #8F9BA7;
         line-height: 20px;
      }
   }
   .menu-btn{
      padding: 0 12px 24px;
   }
   .current-menu{
      color: #F2F2F7;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;
      span{
         color: rgba(46, 104, 246, 1);
      }
   }
   .old-menu{
      color: #8F9BA7;
      font-size: 14px;
      line-height: 20px;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/menu/menudetail.vue